import { Components, stepIconClasses, Theme } from '@mui/material';

export const getMuiStepIcon = (theme: Theme): Components['MuiStepIcon'] => ({
  styleOverrides: {
    root: {
      width: 32,
      height: 32,
      display: 'block',
      color: theme.palette.grey[400],

      [`&.${stepIconClasses.completed}, &.${stepIconClasses.error}`]: {
        color: theme.palette.primary.main,
        fill: theme.palette.primary.main,
      },
    },
    text: {
      fill: theme.palette.grey[400],
    },
  },
});
